module.exports = __webpack_public_path__ + "img/home_top2.b626b911.png";